import { ErrorResponseType } from 'Types/common';

export const serverErrors = {
  400: { message: 'Error.400' },
  403: { message: 'Error.403' },
  502: { message: 'Error.502' },
  503: { message: 'Error.503' },
};

export const getErrorDetail = (error: unknown): string => {
  const errorData = error as ErrorResponseType;
  const errorDetail = errorData?.response?.data?.detail;
  return errorDetail;
};
